import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/slingsite/slingsite/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/slingsite/slingsite/src/components/base-datalayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/slingsite/slingsite/src/components/layout-demo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PictureCode"] */ "/home/runner/work/slingsite/slingsite/src/components/picture-code.tsx");
